var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9589 1.3335C11.3954 1.3335 11.8138 1.50778 12.1194 1.81578L14.1867 3.88304C14.4944 4.19083 14.6674 4.60828 14.6674 5.04355C14.6674 5.47882 14.4944 5.89627 14.1867 6.20405L6.63899 13.7493C6.17333 14.2865 5.51325 14.6165 4.75705 14.6684H1.33398V14.0017L1.33615 11.1917C1.39294 10.4887 1.71976 9.83505 2.21832 9.39578L9.79758 1.81658C10.1049 1.50738 10.5229 1.3335 10.9589 1.3335ZM4.70997 13.3367C5.06612 13.3115 5.39764 13.1457 5.66385 12.8412L10.7051 7.79997L8.2022 5.29696L3.13139 10.3666C2.86129 10.6054 2.69419 10.9397 2.66732 11.2454V13.3355L4.70997 13.3367ZM9.14512 4.35426L11.6479 6.85717L13.2438 5.26124C13.3016 5.20351 13.334 5.1252 13.334 5.04355C13.334 4.9619 13.3016 4.88359 13.2438 4.82585L11.1747 2.75673C11.1176 2.69919 11.0399 2.66683 10.9589 2.66683C10.8778 2.66683 10.8001 2.69919 10.743 2.75673L9.14512 4.35426Z",
    fill: "#091E42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c640d36b.svg";
export { ForwardRef as ReactComponent };